class LanguageInput{
    static init($context = null) {
        let selector = '[data-input="language"]';
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if($(element).data('language_input_instance')) return;
            $(element).data('language_input_instance', new LanguageInput(element))
        });
    }

    constructor(container) {
        this.container = container
        this.$inputFrom = $(container).find('[name$="[from]"]');
        this.$inputTo = $(container).find('[name$="[to]"]');
        this.initEvents();
    }

    initEvents() {

        $(this.container).find('[role="button"]').on('click', function (){
            this.switchLanguages()
        }.bind(this));
    }

    switchLanguages() {
        let languageFrom = this.$inputFrom.val();
        let languageTo = this.$inputTo.val();

        this.$inputFrom.val(languageTo).change();
        this.$inputTo.val(languageFrom).change();
    }
}

LanguageInput.init()
//node modules support
module.exports = LanguageInput;